import "./CustomDropDown.css";
import { FaCaretDown, FaCaretUp } from "react-icons/fa";
import { useState } from "react";
import userService from "../../services/user.service";
import { useDispatch, useSelector } from "react-redux";
import { setAllWeekList } from "../../Redux/Actions/LoginActions";
import { addVideoScheduleInformation } from "../../Redux/Actions/VideoScheduleAction";
import styles from "./FormikInputFields.module.css";
const CustomDropDown = ({
  selected,
  setSelected,
  formik,
  fieldName,
  defaultSelectOption,
  options,
  fieldToShow,
  optionValue,
  isDisabled,
  optionLength,
  isWeekWithOpponent,
  getWeekWithOpponent,
  pageState,
  isEventNameWithPopup,
  setOpen,
  setWeekValueAsWeekName,
  isWeek,
  disabledDropdown,
  isCreatePlaylist,
}) => {
  const [active, setActive] = useState(false);
  const [size, setSize] = useState(optionLength);
  const schoolId = useSelector((state) => state.loggedInUser?.school?.id);
  const currentSeason = useSelector(
    (state) => state.loggedInUser?.currentSeason
  );
  const dispatch = useDispatch();

  const fetchNewWeeks = (limit) => {
    userService
      .getAllSeasonWeeksBySize(schoolId, limit, currentSeason?.id)
      .then((res) => {
        setAllWeekList(dispatch, res.data.data);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  return (
    <>
      <div className={`custom-dropdown ${disabledDropdown && "disabled"}`}>
        <div
          className={`custom-dropdown-btn ${
            formik.errors[fieldName] &&
            formik.touched[fieldName] &&
            styles.error
          }`}
          onClick={() => {
            if (!disabledDropdown) {
              setActive(!active);
            }
          }}
        >
          <p>{selected ? selected : defaultSelectOption}</p>
          {active ? (
            <FaCaretUp style={{ fontSize: "18px" }} />
          ) : (
            <FaCaretDown style={{ fontSize: "18px" }} />
          )}
        </div>
        {active && (
          <div className="custom-dropdown-content">
            {options?.map((item, index) => (
              <div
                className={`custom-dropdown-item ${
                  item[isDisabled] && "disabled-option"
                } ${!item[isDisabled] && "cp"}`}
                key={index}
                onClick={(event) => {
                  if (!item[isDisabled]) {
                    setSelected(item[fieldToShow]);
                    if (setWeekValueAsWeekName) {
                      formik.setFieldValue("uploadVideoWeekName", item.name);
                      addVideoScheduleInformation(dispatch, {
                        fieldName: "uploadVideoWeekName",
                        value: item?.name,
                      });
                    }
                    formik.setFieldValue(fieldName, item[optionValue]);
                    setActive(false);
                  }
                }}
              >
                {item[fieldToShow]}
              </div>
            ))}
            {isDisabled && isWeek && (
              <button
                className="bg-navyBlue semi-bold white fs-13 padding-x-20 padding-y-5 rounded-22 border-none mg-top-10 mg-left-15 mg-bt-10"
                onClick={(e) => {
                  e.stopPropagation();
                  setSize(size + 1);
                  fetchNewWeeks(size + 1);
                }}
                type="button"
              >
                Add More Week
              </button>
            )}

            {isWeekWithOpponent &&
              pageState.currentPageNumber < pageState.totalPages - 1 && (
                <button
                  className="bg-navyBlue semi-bold white fs-13 padding-x-20 padding-y-5 rounded-22 border-none mg-top-10 mg-left-15 mg-bt-10"
                  onClick={(e) => {
                    e.stopPropagation();
                    getWeekWithOpponent(pageState.page + 1, pageState.size);
                  }}
                  type="button"
                >
                  Show More
                </button>
              )}

            {isEventNameWithPopup && (
              <button
                className="bg-navyBlue white fs-13 padding-x-20 padding-y-5 rounded-22 border-none mg-top-10 mg-left-15 mg-bt-10"
                onClick={(e) => {
                  e.stopPropagation();
                  setOpen(true);
                }}
                type="button"
              >
                Create New Event
              </button>
            )}
            {isCreatePlaylist && (
              <button
                className="bg-navyBlue white fs-13 padding-x-20 padding-y-5 rounded-22 border-none mg-top-10 mg-left-15 mg-bt-10"
                onClick={(e) => {
                  e.stopPropagation();
                  setOpen(true);
                }}
                type="button"
              >
                Create New Playlist
              </button>
            )}
          </div>
        )}
      </div>
      <div className="errorMsg fs-14 medium">
        {formik.touched[fieldName] && formik.errors[fieldName]}
      </div>
    </>
  );
};

export default CustomDropDown;
